import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";

const LabelSelectInput = ({ value, setValue, options, defaultText, label }) => {
  return (
    <div className="w-full relative z-50">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <Listbox value={value} onChange={setValue}>
        <div className="relative">
          <Listbox.Button
            className={
              `w-full bg-white mt-1 py-[14px] pl-3 pr-10 text-left rounded-md border border-gray-300 ` +
              `focus:outline-none focus:border-[#1e40af] focus:ring-2 focus:ring-[#1e40af] ` +
              `focus:ring-opacity-50 focus:ring-offset-0 sm:text-sm`
            }
          >
            <span className="block truncate">
              {value.name ? value.name : defaultText}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
            </span>
          </Listbox.Button>

          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute  max-h-44 z-[1000] mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {options.map((option, idx) => (
                <Listbox.Option
                  key={idx}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ` +
                    `${active ? "bg-gray-200 text-blue-600" : "text-gray-900"}`
                  }
                  value={option}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {option.name}
                      </span>
                      {selected && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m4.5 12.75 6 6 9-13.5"
                            />
                          </svg>
                        </span>
                      )}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default LabelSelectInput;
